/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Laptop({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M4 2.4A2.6 2.6 0 0 0 1.4 5v5.4H.75a.6.6 0 0 0-.533.876l.477.92A2.6 2.6 0 0 0 3.002 13.6h9.996a2.6 2.6 0 0 0 2.309-1.404l.476-.92a.6.6 0 0 0-.533-.876h-.65V5A2.6 2.6 0 0 0 12 2.4zm9.4 8V5A1.4 1.4 0 0 0 12 3.6H4A1.4 1.4 0 0 0 2.6 5v5.4zM1.736 11.6l.023.044a1.4 1.4 0 0 0 1.243.756h9.996a1.4 1.4 0 0 0 1.243-.756l.023-.044z" clipRule="evenodd" /></svg>;
}
;